<template>
  <v-form
    :data="form"
    method="patch"
    format="formData"
    :url="$laravel.route('api.account.update')"
    @success="next()"
  >
    <d-card-row>
      <v-insurance :user="$laravel.user" />
    </d-card-row>
    <d-card-row>
      <div class="is-flex is-justify-content-flex-end">
        <button class="button is-primary">
          <span>{{ $t('next') }}</span>
          <span class="icon">
            <i class="mdi mdi-arrow-right" />
          </span>
        </button>
      </div>
    </d-card-row>
  </v-form>
</template>

<script>

import insuranceVue from "@/shared/views/account/fieldsets/insurance.vue";
import { fillFields } from "@/services/helpers";
import Step from "./step";

export default {
  components: {
    "v-insurance": insuranceVue
  },
  extends: Step,
  data () {
    return {
      form: {
        insurance_company: "",
        insurance_number: "",
        insurance_expiry_date: null,
        insurance_picture_upload: null,
        _scenarios: [Registration.scenario]
      }
    };
  },
  created () {
    this.form = fillFields(this.form, this.$laravel.user);
  }
};
</script>
